// services/userSaveWordApi.js

import axios from "axios";
import { makeRequest } from "../utils/handleJWT";
import { checkErrorMessage } from "../utils/responseHandler";

const SAVE_WORD_API_URL =
  "https://umlang.com/userSaveWord/api/v1/userSaveWord/saveWord";

const SAVE_PHRASE_API_URL =
  "https://umlang.com/userSaveWord/api/v1/userSaveWord/savePhrase";

/**
 * ذخیره لغت
 * @param {Object} params - پارامترهای ذخیره لغت
 */
export const saveWord = async (params) => {
  return makeRequest(async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        SAVE_WORD_API_URL,
        {
          fromLang: params.fromLang,
          toLang: params.toLang,
          word: params.word,
          meanings: params.meanings || [],
          subtitle: params.subtitle || "",
          translateOfSubtitle: params.translateOfSubtitle || "",
          subtitleStartTime: params.subtitleStartTime || "",
          subtitleEndTime: params.subtitleEndTime || "",
          movieName: params.movieName || "",
          type: params.type || "word",
          season: params.season || "",
          episode: params.episode || "",
          groups: params.groups || [],
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      // خطای 402 رو جداگانه مدیریت می‌کنیم
      if (error.response?.status === 402) {
        throw error; // این خطا رو به بالا ارسال می‌کنیم تا جداگانه مدیریت بشه
      }

      const errorDetails = checkErrorMessage(error);
      return {
        success: false,
        error: errorDetails.message,
        status: errorDetails.status,
      };
    }
  });
};

/**
 * ذخیره اصطلاح (فقط کاربران ویژه)
 * @param {Object} params - پارامترهای ذخیره اصطلاح
 */
export const savePhrase = async (params) => {
  return makeRequest(async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        SAVE_PHRASE_API_URL,
        {
          fromLang: params.fromLang,
          toLang: params.toLang,
          phrase: params.phrase || "",
          meaning: params.meaning || "",
          category: params.category || "",
          sentence: params.sentence || "",
          sentenceAiTranslate: params.sentenceAiTranslate || "",
          timestamp: params.timestamp,
          movieTitle: params.movieTitle || "",
          season: params.season || "",
          episode: params.episode || "",
          cefr: params.cefr || "",
          partOfSpeech: params.partOfSpeech || "",
          explanation: params.explanation || "",
          examples: params.examples || [],
          synonyms: params.synonyms || [],
          antonyms: params.antonyms || [],
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      // خطای 402 رو جداگانه مدیریت می‌کنیم
      if (error.response?.status === 402) {
        throw error; // این خطا رو به بالا ارسال می‌کنیم تا جداگانه مدیریت بشه
      }

      const errorDetails = checkErrorMessage(error);
      return {
        success: false,
        error: errorDetails.message,
        status: errorDetails.status,
      };
    }
  });
};
